module.exports = __webpack_public_path__ + "img/VL_19_01.0293ff34.png";